<template>
  <div class="water">
    <div class="zhiwei">
      <div class="title">
        <titleCard title='智维-水机管理系统'></titleCard>
      </div>
      <div class="content">
        <div class="left animate__animated wow animate__fadeInLeft">
          融合物联网、云计算等先进技术，实现自动传输水机工作数据，有效提升了透析过程安全性、患者透析质量、科室质控水平，强化中心人员的责任意识。</div>
        <div class="right animate__animated wow animate__fadeInRight">
          <img src="../../assets/image/News/shuiji/shuiji1.webp" alt="">
        </div>
      </div>
      <!-- 核心功能 -->
      <div class="hexin">
        <div class="title">
          <titleCard title="核心功能"></titleCard>
        </div>
        <p class="titletxt">达成信息高效传递，提升设备售后服务质量，<br>实现多样化，更贴心的客户服务。</p>
        <div class="myboxs">
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInLeft"><img
                src="../../assets/image/News/shuiji/shuiji2.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInRight">
              <img src="../../assets/image/News/shuiji/icon3.png" alt="">
              <h3>自动获取</h3>
              <p>可自动获取水机实时工作数据。</p>
            </div>
          </div>
          <div class="mybox">
            <div class="txt txt2 animate__animated wow animate__fadeInLeft">
              <img src="../../assets/image/News/shuiji/icon1.webp" alt="">
              <h3>智能预警</h3>
              <p>报修期限、更换耗材等<br>重要时点提醒和自动预报警。</p>
            </div>
            <div class="pic animate__animated wow animate__fadeInRight"><img
                src="../../assets/image/News/shuiji/shuiji3.webp" alt=""></div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInLeft"><img
                src="../../assets/image/News/shuiji/shuiji4.webp" alt=""></div>
            <div class="txt txt2 animate__animated wow animate__fadeInRight">
              <img src="../../assets/image/News/shuiji/icon4.png" alt="">
              <h3>扫码报修</h3>
              <p>微信扫一扫报修，简单又便捷。</p>
            </div>
          </div>
          <div class="mybox">
            <div class="txt txt2 animate__animated wow animate__fadeInLeft">
              <img src="../../assets/image/News/shuiji/icon5.png" alt="">
              <h3>统计分析</h3>
              <p>多维角度数据分析，提高和<br>改善产品质量，增强管理。</p>
            </div>
            <div class="pic animate__animated wow animate__fadeInRight"><img
                src="../../assets/image/News/shuiji/shuiji5.webp" alt=""></div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInLeft"><img
                src="../../assets/image/News/shuiji/shuiji6.webp" alt=""></div>
            <div class="txt txt2 animate__animated wow animate__fadeInRight">
              <img src="../../assets/image/News/shuiji/icon6.png" alt="">
              <h3>日常记录</h3>
              <p>电子化记录工作数据，可导出打印表单信息。</p>
            </div>
          </div>
          <div class="mybox">
            <div class="txt txt2 animate__animated wow animate__fadeInLeft">
              <img src="../../assets/image/News/shuiji/icon7.png" alt="">
              <h3>全周期管理</h3>
              <p>设备安装、维修、保养的历史记录可追溯。</p>
            </div>
            <div class="pic animate__animated wow animate__fadeInRight"><img
                src="../../assets/image/News/shuiji/shuiji7.webp" alt=""></div>
          </div>
        </div>
        <div class="myiosboxs">
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/shuiji/shuiji2.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/shuiji/icon3.png" alt="">
              <div class="text">
                <h3>自动获取</h3>
                <p>可自动获取水机实时工作数据。</p>
              </div>
            </div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/shuiji/shuiji3.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/shuiji/icon1.webp" alt="">
              <div class="text">
                <h3>智能预警</h3>
                <p>报修期限、更换耗材等，重要时点提醒和自动预报警。</p>
              </div>
            </div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/shuiji/shuiji4.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/shuiji/icon4.png" alt="">
              <div class="text">
                <h3>扫码报修</h3>
                <p>微信扫一扫报修，简单又便捷。</p>
              </div>
            </div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/shuiji/shuiji5.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/shuiji/icon5.png" alt="">
              <div class="text">
                <h3>统计分析</h3>
                <p>多维角度数据分析，提高和改善产品质量，增强管理。</p>
              </div>
            </div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/shuiji/shuiji6.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/shuiji/icon6.png" alt="">
              <div class="text">
                <h3>日常记录</h3>
                <p>电子化记录工作数据，可导出打印表单信息。</p>
              </div>
            </div>
          </div>
          <div class="mybox">
            <div class="pic animate__animated wow animate__fadeInUp"><img
                src="../../assets/image/News/shuiji/shuiji7.webp" alt=""></div>
            <div class="txt animate__animated wow animate__fadeInUp">
              <img src="../../assets/image/News/shuiji/icon7.png" alt="">
              <div class="text">
                <h3>全周期管理</h3>
                <p>设备安装、维修、保养的历史记录可追溯。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerCard name='林老师' phone='135-2227-8747'></footerCard>
  </div>
</template>

<script>
import footerCard from '../../components/footer-card2.vue'
import titleCard from '../../components/title-card.vue'
export default {
  data() {
    return {

    }
  },
  components: {
    footerCard,
    titleCard
  },
  created() {

  },
  mounted() {

  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.water {
  .zhiwei {
    .title {
      padding: 1rem 0 1.4316rem 0;
      @media screen and (max-width: 540px) {
        padding: 37px 0 54px 0;
      }
    }
    .content {
      height: 5.2632rem;
      display: flex;
      align-items: center;
      margin-bottom: 2.2632rem;
      @media screen and (max-width: 540px) {
        display: block;
        height: 100%;
      }
      .left {
        width: 7.2211rem;
        margin-right: 1.6842rem;
        margin-left: 2.3158rem;
        color: #272b2d;
        line-height: 0.4421rem;
        font-size: 0.2726rem;
        @media screen and (max-width: 540px) {
          width: 100%;
          box-sizing: border-box;
          padding: 0 26px;
          margin: 0;
          color: #272b2d;
          font-size: 15px;
          line-height: 26px;
        }
      }
      .right {
        width: 7rem;
        @media screen and (max-width: 540px) {
          width: 100%;
          box-sizing: border-box;
          padding: 0 26px;
          margin: 0;
          height: 280px;
          margin-top: 20px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .hexin {
      .title {
        padding-bottom: 0.5263rem;
      }
      .titletxt {
        color: #666666;
        text-align: center;
        font-size: 0.2526rem;
        line-height: 0.4211rem;
        padding-bottom: 2.1053rem;
        @media screen and (max-width: 540px) {
          color: #666666;
          font-size: 15px;
          line-height: 25px;
        }
      }
      .myboxs {
        @media screen and (max-width: 540px) {
          display: none;
        }
        .mybox {
          display: flex;
          padding: 0 1.6842rem;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.0526rem;
          .pic {
            width: 50%;
            height: 5.2632rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .txt {
            padding-left: 1.1158rem;
            box-sizing: border-box;
            width: 50%;
            img {
              display: block;
              width: 0.5053rem;
              height: 0.4737rem;
            }
            h3 {
              margin: 0;
              padding: 0.3263rem 0 0.4211rem 0;
              color: #333333;
              font-size: 0.2947rem;
            }
            p {
              font-size: 0.2526rem;
              color: #333333;
              line-height: 0.4211rem;
            }
          }
          .txt2 {
            padding-left: 2.1053rem;
          }
        }
      }
      .myiosboxs {
        display: none;
        @media screen and (max-width: 540px) {
          display: block;
        }
        margin-bottom: 150px;
        .mybox {
          padding: 0 14px;
          align-items: center;
          justify-content: center;
          margin-bottom: 36px;
          .pic {
            width: 100%;
            height: 215px;
            margin-bottom: 23px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .txt {
            padding-left: 5px;
            box-sizing: border-box;
            width: 100%;
            display: flex;
            align-items: center;
            img {
              display: block;
              width: 30px;
              height: 28px;
              padding-right: 18px;
            }
            .text {
              h3 {
                margin: 0;
                padding: 0.3263rem 0 0.4211rem 0;
                color: #333333;
                font-size: 17px;
              }
              p {
                font-size: 15px;
                color: #333333;
                padding-right: 50px;
                line-height: 25px;
              }
            }
          }
          .txt2 {
            padding-left: 2.1053rem;
          }
        }
      }
    }
  }
}
</style>
